import React, { useState } from 'react'
import '../styles/Login.css'
import API from '../API/mainApi'

const Login = ({setIsAuth}) => {
    const [type, setType] = useState('signIn')
    const [step, setStep] = useState(1)
    const [mobile, setMobile] = useState('+7')
    const [password, setPassword] = useState('')
    const [fio, setFio] = useState('')
    const [error, setError] = useState('')

    const handleChangeMobile = (e) => {
        setError('')
        let value = e.target.value;
        if (!value.startsWith('+7')) {
            value = '+7';
        }
        if (value.length > 12){
            value = value.slice(0, 12)
        }
        const cleaned = '+7' + value.slice(2).replace(/\D/g, '');
        console.log(cleaned);
        
        setMobile(cleaned);
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            let isButtonActive = false;
            if (type === 'signIn') {
                if (step === 1 && mobile?.length === 12) isButtonActive = true;
                if (step === 2 && password?.length >= 6 && password?.length <= 20) isButtonActive = true;
            } else if (type === 'signUp') {
                if (step === 1 && mobile?.length === 12) isButtonActive = true;
                if (step === 2 && password?.length >= 6 && password?.length <= 20) isButtonActive = true;
                if (step === 3 && fio.trim().split(/\s+/).filter(w => w.length > 2).length >= 2) isButtonActive = true;
            }
            if (isButtonActive) {
                Login();
            }
        }
    };

    const Login = async () => {
        if(type == 'signIn'){
            await API.signIn(step, mobile, password).then(data => {
                (step == 1 && data?.status != 200) ? setError('Пользователь не найден') : 
                (step == 1 && data?.status == 200) ? setStep(2) : 
                (step == 2 && data?.status == 200) ? setIsAuth(true) : setError('Неверные данные') 
            })
            
        }
        else if (type == 'signUp') {
            await API.signUp(step, mobile, password, fio).then(data => {
                console.log(data);
                
                (step == 1 && data?.status == 409) ? setError('Пользователь уже существует') :
                (step == 1 && data?.status == 200) ? setStep(2) : 
                (step == 2 && data?.status == 400) ? setError('Пароль не подходит') :
                (step == 2 && data?.status == 200) ? setStep(3) : 
                (step == 3 && data?.status == 200) ? setIsAuth(true) : setError('Какая-то ошибка')
            })
            
        }
    }
  return (
    <div className='Login'>  
            { type == 'signIn' && <div className="LoginContainer">  
                    <div className="LoginForm">
                        <h1>Вход</h1>
                        <input disabled={step>=2} className='LoginInput' type="tel" value={mobile} onChange={handleChangeMobile} onKeyDown={handleKeyPress} placeholder='+7'/>
                        <input className={`LoginInput ${step < 2 ? 'LoginInputUnshow': '' }`} type="password" value={password} onChange={(e) => {
                            setPassword(e.target.value)
                            setError('')
                            }} onKeyDown={handleKeyPress} placeholder='Пароль'/> 
                    </div>
                    <div className="LoginButtonBlock">
                        {
                            (type == 'signIn' && step < 2) && <button disabled={mobile?.length < 12} className={
                                `LoginButton ${mobile?.length < 12 ? 'LoginDisabled' : '' }`
                            } onClick={Login}>Продолжить</button>
                        }
                        {
                            (type == 'signIn' && step == 2) && <button disabled={password?.length < 6 || password?.length > 20} className={
                                `LoginButton ${(password?.length < 6 || password?.length > 20) ? 'LoginDisabled' : '' }`
                            } onClick={Login}>Войти</button>
                        }
                        {error != '' && <span>{error}</span> }
                        <p onClick={() => {
                            setType('signUp')
                            setError('')
                            setPassword('')
                            setFio('')
                            setStep(1)
                            }}>Регистрация</p>
                    </div>
                </div>
            }
            {type == 'signUp' && <div className="LoginContainer">  
                    <div className="LoginForm">
                        <h1>Регистрация</h1>
                        <input disabled={step>=2} className='LoginInput' type="tel" value={mobile} onChange={handleChangeMobile} onKeyDown={handleKeyPress} placeholder='+7'/>
                        <input disabled={step>2} className={`LoginInput ${step < 2 ? 'LoginInputUnshow': '' }`} type="password" value={password} onChange={(e) => {
                            setPassword(e.target.value)
                            setError('')
                            }} onKeyDown={handleKeyPress} placeholder='Пароль'/> 
                        <input className={`LoginInput ${step < 3 ? 'LoginInputUnshow': '' }`} type="text" value={fio} onChange={(e) => {
                            setFio(e.target.value)
                            setError('')
                            }} onKeyDown={handleKeyPress} placeholder='Фамилия Имя'/> 
        
                    </div>
                    <div className="LoginButtonBlock">
                        {
                            (type == 'signUp' && step == 1) && <button disabled={mobile?.length < 12} className={
                                `LoginButton ${mobile?.length < 12 ? 'LoginDisabled' : '' }`
                            } onClick={Login}>Продолжить</button>
                        }
                        {
                            (type == 'signUp' && step == 2) && <button disabled={password?.length < 6 || password?.length > 20} className={
                                `LoginButton ${(password?.length < 6 || password?.length > 20)? 'LoginDisabled' : '' }`
                            } onClick={Login}>Продолжить</button>
                        }
                        {
                            (type == 'signUp' && step == 3) && <button disabled={!(fio.trim().split(/\s+/).filter(w => w.length > 2).length >= 2)} className={
                                `LoginButton ${!(fio.trim().split(/\s+/).filter(w => w.length > 2).length >= 2) ? 'LoginDisabled' : '' }`
                            } onClick={Login}>Регистрация</button>
                        }
                        {error != '' && <span>{error}</span> }
                        <p onClick={() => {
                            setType('signIn')
                            setError('')
                            setPassword('')
                            setFio('')
                            setStep(1)
                            }}>Вход</p>
                    </div>
                </div>
            }
    </div>
  )
}

export default Login